module.exports = __webpack_public_path__ + "static/media/email-filled-closed-envelope.6cafa332.svg";